import { TFunction } from 'i18next'
import { z, ZodType } from 'zod'

import { Organization } from '@modules-deprecated/app/organization/types/organization'

export interface EditManualBankAccountForm {
  accountName: string
  currencyId: string
  description: string
  reconciliationStartDate: Date | null
}

export type EditManualBankAccountFormSchema = ZodType<EditManualBankAccountForm>

export const getValidationSchema = (t: TFunction): EditManualBankAccountFormSchema =>
  z.object({
    accountName: z.string().trim().min(1, t('required_field')),
    currencyId: z.string().trim().min(1, t('required_field')),
    description: z.string().trim().min(1, t('required_field')),
    reconciliationStartDate: z.date().nullable(),
  })

export const getDefaultValues = (organization?: Organization): EditManualBankAccountForm => ({
  accountName: '',
  currencyId: organization?.baseCurrencyId ?? '',
  description: '',
  reconciliationStartDate: null,
})
